import { render, staticRenderFns } from "./ScrollToTopBtn.vue?vue&type=template&id=bfdc817c&scoped=true"
import script from "./ScrollToTopBtn.vue?vue&type=script&lang=js"
export * from "./ScrollToTopBtn.vue?vue&type=script&lang=js"
import style0 from "./ScrollToTopBtn.vue?vue&type=style&index=0&id=bfdc817c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdc817c",
  null
  
)

export default component.exports